import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const CancelledPurchase = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mt-2">
              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingNine2"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseNine2"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseNine2"
                    >
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">
                          Rejected Purchase Orders
                        </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseNine2"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingNine2"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Payee </th>
                                    <th>Tax</th>
                                    <th>Total Cost</th>
                                    <th>Spread Type</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th class="action-td">Action</th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default CancelledPurchase;
